import { Box, CircularProgress, Stack } from '@mui/material';
import React from 'react';

import { spaces } from '../../../assets/styles/themes/tokens';

const CoursePlayerPageLoader = () => (
	<Stack gap={spaces.xl} height="100%" justifyContent="center" alignItems="center">
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				paddingTop: spaces.xxxl,
				width: '100%',
			}}
			data-testid="course-player-page-loader"
		>
			<CircularProgress
				sx={{
					'& .MuiCircularProgress-svg': {
						height: 'auto',
						width: 'auto',
					},
				}}
				size={60}
			/>
		</Box>
	</Stack>
);

export default CoursePlayerPageLoader;
